import { convertFileToBase64 } from "../../utils/fileToBase64";
import { compressImageFile } from "../../utils/compressImage";

// Convierte un archivo nuevo a data URL, comprimido si es una foto grande.
// Las URLs existentes pasan tal cual; si la compresión falla se usa el
// original (mismo comportamiento que antes).
const processImage = async (image) => {
  if (!(image.rawFile instanceof File)) return image;
  try {
    const compressed = await compressImageFile(image.rawFile);
    if (compressed) return compressed;
  } catch (e) {
    // fallback al original
  }
  return convertFileToBase64(image.rawFile);
};

export const transformTourPackage = ({ params }) => {
  return Promise.all((params.data.images || []).map(processImage)).then(
    (images) => ({
      ...params,
      data: {
        ...params.data,
        images,
      },
    })
  );
};
